// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { getStorage, ref } from "firebase/storage";
import { getFunctions } from "firebase/functions";
import { getDatabase } from "firebase/database";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyDI8GEU9X64aK_u2GOrKIRj8xDR8SseBIQ",
  authDomain: "lifepoints-6ced1.firebaseapp.com",
  projectId: "lifepoints-6ced1",
  databaseURL: "https://lifepoints-6ced1-default-rtdb.firebaseio.com/",
  storageBucket: "lifepoints-6ced1.appspot.com",
  messagingSenderId: "714326881434",
  appId: "1:714326881434:web:004f230eaa0fa62eb25b23",
  measurementId: "G-WLFCG02LXD",
};

// Initialize Firebase

const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
export const realDb = getDatabase(app);
export const functions = getFunctions(app);
export const user = getAuth(app);
export const storage = getStorage(app);
export default db;
